import axios from 'axios';

export const searchTypes = {
  ad: 'ad',
  account: 'account',
  contentOrigin: 'content-origin',
  contentStream: 'content-stream',
  user: 'user',
  advertiser: 'advertiser',
  campaign: 'campaign',
  contentStreamEvent: 'content-stream-event',
  lineItem: 'line-item',
  macroReplacement: 'macro-replacement',
  contentStreamTag: 'content-stream-tag',
  inventoryEventType: 'inventory-event-type',
  supplyRoute: 'supply-route',
  configuration: 'configuration',
  stream: 'stream',
  contentStreamExtensionTargeting: 'content-stream-extension-targeting',
};

export const searchDocs = async (searchTerms) => {
  const url = `${SERVICE_URL}/api/v1/search`;
  return axios.post(url, searchTerms).then((response) => {
    return response.data;
  });
};

export const searchInputs = async (searchTerms) => {
  const url = `${SERVICE_URL}/api/v1/search-inputs`;
  return axios.post(url, searchTerms).then((response) => {
    return response.data;
  });
};

export const searchExtensionTargeting = async (searchTerms) => {
  const url = `${SERVICE_URL}/api/v1/search-extension-targeting`;
  return axios.post(url, searchTerms).then((response) => {
    return response.data;
  });
};

export const searchSportRadarMetadata = async (searchTerms) => {
  const url = `${SERVICE_URL}/api/v1/search-sport-radar-metadata`;
  return axios.post(url, searchTerms).then((response) => {
    return response.data;
  });
};
